var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    { attrs: { id: "container" } },
    [
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("用户信息")]),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" UUID： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(_vm.initData[`${_vm.type}Uuid`]) + " "),
                  ]),
                ]),
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" 用户昵称： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(_vm.initData.username) + " "),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(" 用户手机号： "),
                  ]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(_vm.initData.mobile) + " "),
                  ]),
                ]),
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" 会员类型: ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(_vm.userMemberType) + " "),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("设备信息")]),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" HID： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.initData[`${_vm.type}HardwareId`]) + " "
                    ),
                  ]),
                ]),
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" UID： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(" " + _vm._s(_vm.initData[`${_vm.type}Uid`]) + " "),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" 渠道来源： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.initData[`${_vm.type}Appid`]) +
                        " " +
                        _vm._s(_vm.getChannelNameDisplay(_vm.type)) +
                        " "
                    ),
                  ]),
                ]),
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" 设备厂商： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.initData[`${_vm.type}DeviceBrand`]) + " "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" 设备型号：")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.initData[`${_vm.type}DeviceModel`]) + " "
                    ),
                  ]),
                ]),
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(" App 版本号： "),
                  ]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.initData[`${_vm.type}AppVersion`]) + " "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(" SDK 版本号： "),
                  ]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " + _vm._s(_vm.initData[`${_vm.type}SdkVersion`]) + " "
                    ),
                  ]),
                ]),
                _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                  _c("span", { staticClass: "name" }, [_vm._v(" IP： ")]),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      "  " +
                        _vm._s(
                          _vm.initData[`${_vm.type}Ip`] ||
                            _vm.initData[`${_vm.type}DeviceIp`]
                        ) +
                        "  （ " +
                        _vm._s(
                          _vm.initData[`${_vm.type}IpAddress`] ||
                            _vm.initData[`${_vm.type}DeviceIpAddress`] ||
                            "-"
                        ) +
                        "   ）  "
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.initData.castType === "push"
        ? _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "title" }, [_vm._v("推送信息")]),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { staticClass: "_col", attrs: { span: 12 } }, [
                      _c("span", { staticClass: "name" }, [
                        _vm._v("媒资类型："),
                      ]),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          _vm._s(_vm.getMimeTypeName(_vm.initData.mimeType))
                        ),
                      ]),
                    ]),
                    _c("el-col", { staticClass: "_col", attrs: { span: 24 } }, [
                      _c("span", { staticClass: "name" }, [_vm._v("URL：")]),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.initData.url || "-")),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", [_vm._v("投屏事件流")]),
        ]),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("EventFlow", {
              ref: "EventFlow",
              attrs: {
                castType: _vm.initData.castType || "mirror",
                uri: _vm.$route.query.uri,
                pdate: _vm.$route.query.pdate,
                serviceType: _vm.initData.serviceType,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "section", staticStyle: { "margin-top": "63px" } },
        [
          _c("div", { staticClass: "title" }, [
            _c(
              "div",
              [
                _vm._v(
                  _vm._s(_vm.initData.castType === "push" ? "" : "实时质量") +
                    " \n        "
                ),
                _vm.initData.castType !== "push"
                  ? _c("span", {
                      staticClass: "el-icon-refresh-left _btn",
                      on: { click: _vm.renovateFlow },
                    })
                  : _vm._e(),
                _vm.initData.castType === "push"
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleLogReport },
                      },
                      [_vm._v("日志上报")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm.initData.castType !== "push"
            ? _c("RealTimeQuality", {
                ref: "RealTimeQuality",
                attrs: {
                  uid: _vm.initData[`${_vm.type}Uid`],
                  appid: _vm.initData[`${_vm.type}Appid`],
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "日志上报",
            visible: _vm.logDialogVisible,
            width: "500px",
            "close-on-click-modal": true,
            "close-on-press-escape": true,
            "append-to-body": true,
            "modal-append-to-body": true,
            "lock-scroll": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题描述：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入问题描述",
                          maxlength: "500",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.faultDescription,
                          callback: function ($$v) {
                            _vm.faultDescription = $$v
                          },
                          expression: "faultDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.logDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.logLoading },
                  on: { click: _vm.confirmSendLog },
                },
                [_vm._v("上报")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }